import { initData, leitingDownload } from "@api/index";

const state = {
  initData: {
    base_info: {},
    frament: [],
    menu: []
  },
  downloadUrl: {
    android_url: "",
    ios_url: ""
  }
};

const mutations = {
  SET_INIT_DATA(state, payload) {
    state.initData = payload;
  },
  SET_DOWNLOAD_URL(state, payload) {
    state.downloadUrl = payload;
  }
};
const actions = {
  GET_INIT({ commit }) {
    initData()
      .then(res => {
        window.$(".loading-wrap").fadeOut();
        document.title = res.base_info.title;
        window
          .$('meta[property="og:title"]')
          .attr("content", res.base_info.title);
        window
          .$('meta[property="og:sub_title"]')
          .attr("content", res.base_info.sub_title);
        window
          .$('meta[property="og:description"]')
          .attr("content", res.base_info.description);
        window
          .$('meta[property="description"]')
          .attr("content", res.base_info.description);
        commit("SET_INIT_DATA", res);
      })
      .catch(() => {
        window.$(".loading-wrap").fadeOut();
      });
    leitingDownload("id").then(res => {
      commit("SET_DOWNLOAD_URL", res.download_arr);
    });
  }
};

export default {
  state,
  mutations,
  actions
};
